// src/components/ChangeHistoryPanel.js
import React, { useState } from 'react';

/**
 * Panel lateral colapsable con últimos 10 cambios.
 */
const ChangeHistoryPanel = ({ history = [] }) => {
  const [open, setOpen] = useState(false);
  return (
    <div style={{ position: 'fixed', right: 0, top: '30%', zIndex: 20 }}>
      <button
        onClick={() => setOpen(!open)}
        style={{
          position: 'absolute',
          left: open ? '-42px' : 0,
          transform: 'translateX(-100%)',
          padding: '8px 10px',
          borderRadius: '8px 0 0 8px',
          border: '1px solid var(--border-color)',
          background: 'var(--bg-secondary)',
          color: 'var(--text-primary)',
          cursor: 'pointer',
        }}
        title={open ? 'Cerrar historial' : 'Abrir historial'}
      >
        🕘
      </button>
      {open && (
        <div style={{
          width: 260,
          maxHeight: 360,
          overflow: 'auto',
          background: 'var(--bg-panel)',
          border: '1px solid var(--border-color)',
          borderRight: 'none',
          borderRadius: '8px 0 0 8px',
          boxShadow: 'var(--shadow-medium)',
          padding: 10
        }}>
          <div style={{ fontWeight: 600, marginBottom: 8 }}>Historial de cambios</div>
          {history.length === 0 && (
            <div style={{ fontSize: 13, opacity: 0.8 }}>Sin cambios recientes</div>
          )}
          {history.map((h) => (
            <div key={`${h.id}-${h.ts}`} style={{ fontSize: 13, padding: '6px 0', borderBottom: '1px dashed var(--border-color)' }}>
              <div style={{ fontWeight: 600 }}>{h.nombre}</div>
              <div style={{ opacity: 0.8 }}>Estado: {h.estado}</div>
              <div style={{ opacity: 0.6 }}>{new Date(h.ts).toLocaleString()}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ChangeHistoryPanel;


